module.exports = __webpack_public_path__ + "img/local-cluster.c77b2023.svg";